export default __webpack_public_path__ + "static/media/iconCheckCircle.191a50a8.svg";